import { styled } from 'goober';

const FixedBottomContainerDiv = styled('div')`
  width: 100%;
  max-width: 100%;
  background-color: #ffffff;
  padding: 0 10px;
`;

const FixedBottomContainer = ({ children }) => {
  return <FixedBottomContainerDiv>{children}</FixedBottomContainerDiv>;
};
export default FixedBottomContainer;



// WEBPACK FOOTER //
// ./components/checkoutWidget/FixedBottomContainer.js